import { ButtonERP, PrimeReactModal } from "@finanedi.es/storybook"
import { MODAL_STYLES } from "constants/primereactStyles"
import { TFunction } from "i18next"

export interface ModalDepartamentosDeleteProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
  t: TFunction
}

export default function ModalDepartamentosDelete({
  isOpen = true,
  onCancel,
  onConfirm,
  t,
}: ModalDepartamentosDeleteProps) {
  return (
    <PrimeReactModal
      visible={isOpen}
      closable={false}
      ptContext={MODAL_STYLES}
      className='tw-w-128 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
      baseZIndex={20}
      keepInViewport={false}
      header={
        <div className='tw-text-2xl tw-font-medium tw-text-primary tw-pb-4'>
          {`${t(
            "gestionUsuarios.departamentos.table.deleteDepartament.title"
          )}`}
        </div>
      }
    >
      <div className='tw-flex tw-flex-col tw-text-base tw-font-normal tw-pb-4 tw-text-text'>
        <p>{t("gestionUsuarios.departamentos.table.deleteDepartament.text")}</p>
      </div>
      <div
        key='actions'
        className='tw-pb-1 tw-flex tw-flex-col sm:tw-flex-row tw-justify-end tw-gap-4'
      >
        <ButtonERP
          customize={{
            type: "transparent",
            size: "md",
          }}
          label={`${t(
            "gestionUsuarios.departamentos.table.deleteDepartament.cancelButton"
          )}`}
          onClick={onCancel}
        />
        <ButtonERP
          customize={{
            type: "primary",
            size: "md",
          }}
          label={`${t(
            "gestionUsuarios.departamentos.table.deleteDepartament.deleteButton"
          )}`}
          onClick={onConfirm}
        />
      </div>
    </PrimeReactModal>
  )
}
